// import reducers from connected features, add them to the combined root reducer below
import app from 'redux/domain/App/reducer';
import appStatus from 'redux/domain/AppStatus/reducer';
import asyncStatus from 'redux/domain/AsyncStatus/reducer';
import brandInfo from 'redux/domain/BrandInfo/reducer';
import cache from 'redux/domain/Cache/reducer';
import findCustomer from 'redux/domain/FindCustomer/reducer';
import notifications from 'redux/domain/Notifications/reducer';
import termsAndConditions from 'redux/domain/TermsAndConditions/reducer';
import user from 'redux/domain/User/Authentication/reducer';
import welcome from 'redux/domain/Welcome/reducer';
import { combineReducers } from 'redux';
import { enableBatching } from 'redux-batched-actions';
import { reducer as form } from 'redux-form';

const reducers = combineReducers({
	app,
	appStatus,
	asyncStatus,
	brandInfo,
	cache,
	findCustomer,
	form,
	notifications,
	termsAndConditions,
	user,
	welcome,
});

export default enableBatching(reducers);
